"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AVIARY_INTENTIONS = void 0;
var AVIARY_INTENTIONS = {
  primary: "primary",
  system: "system",
  danger: "danger",
  success: "success",
  textSuccess: "textSuccess",
  textSystem: "textSystem",
  textDanger: "textDanger",
  lightFilled: "lightFilled",
  lightOutlined: "lightOutlined",
  lightText: "lightText"
};
exports.AVIARY_INTENTIONS = AVIARY_INTENTIONS;